import React from 'react';
import { Card, CardTitle, CardText } from 'react-md';
import { aladb } from 'db'
import _ from 'lodash'
import { Chart } from 'react-google-charts';

import './CardMobileUsage.css'

export default () => {
	const sqlData = aladb.db.exec("SELECT mobile, COUNT(*) AS cnt FROM Log GROUP BY mobile ORDER BY COUNT(*) DESC");

	const data = [
		['Mobile', 'Count'],
		..._.map(sqlData, v => [v.mobile, v.cnt])
	];

	const options = {
		pieHole: 0.4,
		legend: {
			alignment: "center",
			position: 'right',
			textStyle: {fontSize: 20}
		},
		chartArea: {
			top: 10,
			bottom: 10,
			left: 10,     // set this eventually, to adjust the left margin
			right: 5
		},
		fontSize: 16,
	};

	return (
		<Card>
			<CardTitle title="Welche Geräte werden eingesetzt?"/>
			<CardText>
				<Chart
					chartType="PieChart"
					data={data}
					options={options}
					graph_id="chart-mobile-usage"
				/>
			</CardText>
		</Card>
	);
};


// WEBPACK FOOTER //
// ./src/components/summary/cards/CardMobileUsage.jsx